import React from 'react'
// import ProjectCard from './projectcard'

const Blog = () => {
  return (
    <>
    <div id='projects'>
        <h2 className="md:text-5xl text-center font-bold text-white text-4xl pt-10">
        📄 Projects
        </h2>
        <section className='flex flex-col justify-center items-center h-screen text-white text-base md:text-3xl'>
            <p>🚧 Section under construction</p>
            <p className='m-4 text-center text-base'>Sorry for the inconvinience, download resume for latest project details</p>
            <a href='#experience' className='mt-4 text-lg underline text-[#6784f7]'>continue scrolling</a> 
        </section>
    </div>
    </>
  )
}

export default Blog